var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTrips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 25.4667L20.6667 28.5333C20.4 28.6667 20.2667 28.6667 20 28.5333L12.5333 25.6C12.2667 25.4667 12.1333 25.4667 11.8667 25.6L4 28.6667V14L12 10.6667C12.2667 10.5333 12.4 10.5333 12.6667 10.6667L17.3333 12.8",
    stroke: "#047B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7332 10.9333C24.7641 10.9333 25.5999 10.0975 25.5999 9.06667C25.5999 8.03578 24.7641 7.2 23.7332 7.2C22.7023 7.2 21.8665 8.03578 21.8665 9.06667C21.8665 10.0975 22.7023 10.9333 23.7332 10.9333Z",
    stroke: "#047B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9336 17.4667C23.3336 18.0001 24.0003 18.0001 24.4003 17.4667C25.6003 15.8667 27.8669 12.9334 28.5336 10.6667C28.9336 9.33341 28.5336 7.73341 28.4003 7.20008C27.7336 5.60008 26.2669 4.00008 23.7336 4.00008C21.3336 4.00008 19.8669 5.60008 19.2003 7.06675C18.9336 7.46675 18.5336 9.06675 18.9336 10.6667C19.6003 12.9334 21.8669 15.8667 22.9336 17.4667Z",
    stroke: "#047B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4004 15.4666V25.4666",
    stroke: "#047B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4004 18.8V28.6667",
    stroke: "#047B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2671 11.2V25.2",
    stroke: "#047B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrips);
export default __webpack_public_path__ + "static/media/ic_trips.405531fbacb4456d6aef132d36e8cedf.svg";
export { ForwardRef as ReactComponent };